import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import HookedTextFieldCreditCard from 'components/standard/Form/HookedTextFieldCreditCard';
import HookedTextFieldMonth from 'components/standard/Form/HookedTextFieldMonth';
import HookedTextField from 'components/standard/Form/HookedTextField';
import InputAdornment from '@liquidweb-dev/undercurrent/InputAdornment';
import LockIcon from '@liquidweb-dev/undercurrent/icons/lucide/Lock';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export type HookedCreditCardFieldsProps = StackProps;

const HookedCreditCardFields = ({
	sx,
	...rest
}: HookedCreditCardFieldsProps) => (
	<Stack sx={combineSx({ gap: 200 }, sx)} {...rest}>
		<HookedTextFieldCreditCard name="cardNumber" fullWidth />

		<Stack sx={{ flexDirection: 'row', gap: 200 }}>
			<HookedTextFieldMonth
				name="expirationDate"
				label="Expiry date"
				autoComplete="cc-exp"
				fullWidth
			/>

			<HookedTextField
				name="cardCode"
				label="Security code"
				placeholder="CVV"
				autoComplete="cc-csc"
				slotProps={{
					input: {
						endAdornment: (
							<InputAdornment position="end" sx={{ opacity: 0.5 }}>
								<LockIcon />
							</InputAdornment>
						),
					},
				}}
				fullWidth
			/>
		</Stack>
	</Stack>
);

export default HookedCreditCardFields;
